<form #ideaForm="ngForm" (ngSubmit)="submit()">
  <ng-container *ngIf="!showFileUpload">
    <div class="row">
      <div class="col-12">
        <label for="ideaName">Your Idea</label>
        <input
          #nameControl="ngModel"
          name="ideaName"
          required
          id="ideaName"
          type="text"
          class="form-control"
          placeholder="One Sentence Summary of Your Idea"
          [(ngModel)]="ideaName"
          [class.mb-0]="nameControl.invalid && nameControl.touched" />
        <small class="form-text error-text" *ngIf="nameControl.invalid && nameControl.touched"
          >You must fill in this field.</small
        >
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label for="ideaDescription">Please Add More Details </label>
        <textarea
          #descriptionField="ngModel"
          required
          name="ideaDescription"
          id="ideaDescription"
          class="form-control"
          placeholder="Why is it useful, who would benefit from it, how should it work?"
          [(ngModel)]="ideaDescription"
          [class.mb-0]="descriptionField.invalid && descriptionField.touched"></textarea>
        <small
          class="form-text error-text"
          *ngIf="descriptionField.invalid && descriptionField.touched"
          >You must fill in this field.</small
        >
      </div>
    </div>
    <ng-container *ngIf="files != null && files.length > 0 && !showFileUpload">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let file of files">
          <div class="row">
            <div class="col-10">{{ file.name }}</div>
            <div class="col-2">
              <button (click)="onFileRemoved(file)" class="btn btn-danger">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>
    <div class="row mb-3">
      <div class="col-12 text-end">
        <button type="button" (click)="showFileUpload = true" class="btn btn-secondary">
          Attach File <i class="fas fa-paperclip"></i>
        </button>
        <button [disabled]="ideaForm.invalid" class="btn btn-primary">Submit Idea</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="showFileUpload">
    <input
      name="files"
      (change)="onFileSelected($event)"
      class="form-control"
      type="file"
      multiple
      #fileUpload />
    <button (click)="showFileUpload = false" class="btn btn-secondary">
      I am finished selecting files.
    </button>
    <ul class="list-group">
      <li class="list-group-item" *ngFor="let file of files">
        <div class="row">
          <div class="col-10">{{ file.name }}</div>
          <div class="col-2">
            <button (click)="onFileRemoved(file, fileUpload)" class="btn btn-danger">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </ng-container>
</form>
